import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { AppLocale, LocaleService } from '../services/common/locale.service';

/**
 * Sets the active locale based on the `locale` value in the
 * route's `data` object, then passes through.
 *
 * Usage in routes:
 *   { path: 'fr', canActivate: [localeGuard], data: { locale: 'fr' }, children: [...] }
 */
export const localeGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const localeService = inject(LocaleService);
  const locale = (route.data?.['locale'] as AppLocale) ?? 'en';
  localeService.setLocale(locale);
  return true;
};
